import React from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import pdf from "../assets/cv.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { Worker, Viewer, SpecialZoomLevel } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import './CV.css';

function CV() {
    return (
        <div>
            <Container fluid className="resume-section">
                <Row className="resume d-flex justify-content-center">
                    <div className="pdf-viewer-wrapper">
                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                            <Viewer
                                fileUrl={pdf}
                                defaultScale={SpecialZoomLevel.PageFit}
                            />
                        </Worker>
                    </div>
                </Row>
                <Row style={{ justifyContent: "center", position: "relative", padding: "5vh" }}>
                    <Button
                        variant="primary"
                        href={pdf}
                        target="_blank"
                        style={{ maxWidth: "250px" }}
                    >
                        <AiOutlineDownload />
                        &nbsp;Download CV
                    </Button>
                </Row>
            </Container>
        </div>
    );
}

export default CV;
